module.exports = __webpack_public_path__ + "img/id-card.d4b297af.svg";